import { get, post } from '@/plugins/http'

export default {
  classSearchList: get('/live/api/v1/live/search'),
  annexDownload: post('/live/api/v1/productManual/annexDownload'),
  //律师服务中台推荐列表
  recommended: get('/live/api/v1/live/recommended'),
  productManualDetail: get('live/api/v1/live/productManual/{id}'),
  liveCourseDetail: get('live/api/v1/live/liveCourse/{id}'),
  queryVideoList: get('live/api/v1/video/queryVideoList'),
  queryVideoDetail: get('live/api/v1/video/queryVideoDetail'),
  activate: get('live/api/v1/knowledge/activate'),
}
